@if (auction) {
	@let itsBlind = auction.type === "BLIND";
	<ul class="row g-0 mb-0 px-0">
		@if (!itsBlind) {
			<li class="col-6 col-lg-2 d-flex flex-row">
				<div class="bg-icon relaunch ps-3 pe-4 pt-3 pb-4"></div>
				<div
					class="lh-sm pe-2 text-truncate"
					title="{{ 'auction.details.minRelaunch' | translate }}: {{ auction?.minRelaunch }}"
				>
					<strong>{{ auction?.minRelaunch }}</strong>
					<br />
					<span class="text-gray text-sm">{{ "auction.details.minRelaunch" | translate }}</span>
				</div>
			</li>
		}
		<li class="col-6 col-lg-2 d-flex flex-row">
			<div class="bg-icon offer ps-3 pe-4 pt-3 pb-4"></div>
			<div
				class="lh-sm pe-2 text-truncate"
				title="{{ 'auction.details.minOfferNumber' | translate }}: {{ auction?.minOfferNumber }}"
			>
				<strong>{{ auction?.minOfferNumber }}</strong>
				<br />
				<span class="text-gray text-sm">{{ "auction.details.minOfferNumber" | translate }}</span>
			</div>
		</li>
		@if (!itsBlind) {
			<li class="col-6 col-lg-2 d-flex flex-row mt-3 mt-lg-0">
				<div class="bg-icon time ps-3 pe-4 pt-3 pb-4"></div>
				<div
					class="lh-sm pe-2 text-truncate"
					title="{{ 'auction.details.extraTime' | translate }}: {{ auction?.extraTime }}"
				>
					<strong>{{ auction?.extraTime }}</strong>
					<br />
					<span class="text-gray text-sm">{{ "auction.details.extraTime" | translate }}</span>
				</div>
			</li>
		}
		<li class="col-6 col-lg-2 d-flex flex-row mt-3 mt-lg-0">
			<div class="bg-icon price ps-3 pe-4 pt-3 pb-4"></div>
			@let yesOrNo = auction?.reservePrice ? "auction.details.yes" : "auction.details.no";
			<div
				class="lh-sm pe-2 text-truncate"
				title="{{ 'auction.details.hiddenReservePrice' | translate }}: {{ yesOrNo | translate }}"
			>
				<strong>{{ yesOrNo | translate }}</strong>
				<br />
				<span class="text-gray text-sm">{{ "auction.details.hiddenReservePrice" | translate }}</span>
			</div>
		</li>
		<li class="col-6 col-lg-2 d-flex flex-row mt-3 mt-lg-0">
			<div class="bg-icon calendar ps-3 pe-4 pt-3 pb-4"></div>
			<div
				class="lh-sm pe-2 text-truncate"
				title="{{ 'auction.details.startDate' | translate }}: {{ auction?.startDate | ckDate }} {{ auction?.startDate | ckDate: false : false : false : true }}"
			>
				<strong>
					{{ auction?.startDate | ckDate }}
					{{ auction?.startDate | ckDate: false : false : false : true }}
				</strong>
				<br />
				<span class="text-gray text-sm">{{ "auction.details.startDate" | translate }}</span>
			</div>
			<br />
		</li>
		<li class="col-6 col-lg-2 d-flex flex-row mt-3 mt-lg-0">
			<div class="bg-icon closed ps-3 pe-4 pt-3 pb-4"></div>
			<div
				class="lh-sm pe-2 text-truncate"
				title="{{ 'auction.details.endDate' | translate }}: {{ auction?.endDate | ckDate }} {{ auction?.endDate | ckDate: false : false : false : true }}"
			>
				<strong>
					{{ auction?.endDate | ckDate }}
					{{ auction?.endDate | ckDate: false : false : false : true }}
				</strong>
				<br />
				<span class="text-gray text-sm">{{ "auction.details.endDate" | translate }}</span>
			</div>
		</li>
	</ul>
}